
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embeds/projectfinder/[uId]",
      function () {
        return require("private-next-pages/embeds/projectfinder/[uId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embeds/projectfinder/[uId]"])
      });
    }
  